import { render, staticRenderFns } from "./Bildungsgang.vue?vue&type=template&id=16dadb5c&"
import script from "./Bildungsgang.vue?vue&type=script&lang=js&"
export * from "./Bildungsgang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports